import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import 'rxjs/add/observable/interval';
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/timer';
import 'rxjs/add/operator/delay';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/takeWhile';
import { Proband } from '../../data/data';
import { MPTPage } from '../mpt/mpt';

@Component({
    selector: 'page-instructions',
    templateUrl: 'instructions.html'
})
export class InstructionsPage {

    public proband: Proband;

    constructor(
        private navCtrl: NavController,
        private navParams: NavParams
    ) {
        this.proband = this.navParams.get('proband');
    }

    public start() {
        const session = this.proband.newSession();
        this.navCtrl.push(MPTPage, { proband: this.proband, session : session });
    }
}



// WEBPACK FOOTER //
// ./src/pages/instructions/instructions.ts